import { render, staticRenderFns } from "./relativeDateTypeFilterElement.vue?vue&type=template&id=3d5b18e8"
import script from "./relativeDateTypeFilterElement.vue?vue&type=script&lang=js"
export * from "./relativeDateTypeFilterElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports